import { LocalizedNewsPost, LocalizedNewsPostContent } from 'apollo/localizedTypes';

const orderNewsPostContent = (
  newsPost: LocalizedNewsPost | undefined
): LocalizedNewsPostContent[] => {
  if (!newsPost || !newsPost.contents) return [];
  const arrayToOrder = [...newsPost.contents];
  const orderedContent = arrayToOrder.sort((a, b) => a.order - b.order);
  return orderedContent;
};

export default orderNewsPostContent;
